import { BreakpointOverrides } from "@mui/material";

export const BORDER_RADIUS = Object.freeze({
  default: "4px",
});

export const PADDING = Object.freeze({
  small: "8px",
  medium: "16px",
  default: "24px",
  big: "40px",
});

type Brekpoint = keyof Pick<
  BreakpointOverrides,
  "mobileXs" | "mobileXl" | "tabletXs" | "tabletXl" | "laptopXs" | "laptopXl"
>;

export const BREAKPOINTS: {
  [breakpoint in Brekpoint]: { minWidth: number; maxWidth: number };
} = {
  mobileXs: {
    minWidth: 0,
    maxWidth: 550,
  },
  mobileXl: {
    minWidth: 551,
    maxWidth: 803,
  },
  tabletXs: {
    minWidth: 804,
    maxWidth: 1070,
  },
  tabletXl: {
    minWidth: 1071,
    maxWidth: 1278,
  },
  laptopXs: {
    minWidth: 1279,
    maxWidth: 1530,
  },
  laptopXl: {
    minWidth: 1531,
    maxWidth: 1919,
  },
  // mobileXs: {
  //   minWidth: 0,
  //   maxWidth: 600,
  // },
  // mobileXl: {
  //   minWidth: 601,
  //   maxWidth: 900,
  // },
  // tabletXs: {
  //   minWidth: 901,
  //   maxWidth: 1200,
  // },
  // tabletXl: {
  //   minWidth: 1201,
  //   maxWidth: 1440,
  // },
  // laptopXs: {
  //   minWidth: 1441,
  //   maxWidth: 1800,
  // },
  // laptopXl: {
  //   minWidth: 1801,
  //   maxWidth: 1920,
  // },
};
